<script setup lang="ts">
import { AddressClient } from '@/api/modules/addresses/addresses.types'

import { formatToFullVisibleAddress } from '@/utils/formatToFullVisibleAddress'

type Props = {
  address: AddressClient
}

const props = defineProps<Props>()

// Отображаем город с поселком или же город
const correctAddress = computed(() => formatToFullVisibleAddress(props.address))

const correctCity = computed(() => {
  if (!props.address.alias) return `г. ${props.address.city}`

  return `г. ${props.address.city}, ${props.address.alias}`
})
</script>

<template>
  <div class="address-item">
    <div class="address-wrapper">
      <div class="address">
        {{ correctAddress }}
      </div>
    </div>

    <div v-if="props.address.city" class="address-item__city">
      {{ correctCity }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.address-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;

  &__city {
    font-size: 12px;
    font-weight: 600;
    color: $dark-grey;
  }
}
.address {
  font-size: 14px;
  font-weight: 600;
  color: $text-black;
}
.address-wrapper {
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-right: 40px;

  @include media('<portrait-phone') {
    margin-right: 14px;
  }
}
</style>
